import { types } from "../types/types";

export const setFiltrosVisorAsignacion = (filtros) => ({
  type: types.setFiltrosVisorAsignacion,
  payload: filtros,
});

export const setFiltrosVisorSeguimiento = (filtros) => ({
  type: types.setFiltrosVisorSeguimiento,
  payload: filtros,
});
